import React from 'react';
import { useTranslation } from 'react-i18next';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { usePronunciationContext } from '@src/contexts/PronunciationCheckContext';
import sanitize from 'sanitize-html';
import pluralize from '@src/utils/pluralize';
import { StyledChip, StyledNoIssueChip } from './index.style';

const PronunciationChip = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const { remainingCount, hasChecked, isLoading, openSideBox, noIssuesFound } =
    usePronunciationContext();

  if (isLoading) return null;

  if (noIssuesFound) {
    return <StyledNoIssueChip>{t('noPronunciationIssues')}</StyledNoIssueChip>;
  }

  if (!hasChecked || remainingCount === 0) return null;

  return (
    <StyledChip type="button" onClick={openSideBox}>
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: sanitize(
            t('pronunciationCount', {
              count: remainingCount,
              words: pluralize(remainingCount, t('wordCharacter'), language),
            }),
          ),
        }}
      />
      <ChevronRightIcon sx={{ fontSize: 16 }} />
    </StyledChip>
  );
};

export default PronunciationChip;
